<div class="dialog-title">{{editNew}}</div>
<form [formGroup]="itemDialogForm">
  <mat-form-field>
    <input matInput formControlName="code" required placeholder="Code" />
    <mat-error>Code name is required.</mat-error>
  </mat-form-field>

  <mat-form-field>
    <input matInput formControlName="description" required placeholder="Description" />
    <mat-error>Description is required.</mat-error>
  </mat-form-field>

  <div class="dialog-buttons">
    <button mat-button color="primary" [mat-dialog-close]="false">Cancel</button>
    <button mat-button color="primary" (click)="save()">Confirm</button>
  </div>
</form>
